import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { RCS_NOTIFY_PREFS_DEFAULT, RcsNotifyPrefs } from 'src/app/models/Rcs';
import { environment } from 'src/environments/environment';

/**
 * Preferências de aviso do cliente (`GET/PUT /api/rcs/notify-prefs`, 17tm466frtx):
 * coluna "Como avisamos você" da tela Agentes RCS. O painel (sino) é sempre ligado
 * e os eventos de `locked_events` não mudam pela tela; WhatsApp e SMS aparecem como
 * "em breve" (`available: false`) até existir número oficial — decisão do Bruno de
 * 22/10, sem data.
 */
@Injectable({ providedIn: 'root' })
export class RcsNotifyPrefsService {

  private readonly url = `${environment.apiUrl}/rcs/notify-prefs`;

  constructor(private http: HttpClient) {}

  get(): Observable<RcsNotifyPrefs> {
    return this.http.get<RcsNotifyPrefs>(this.url).pipe(
      map(response => ({ ...RCS_NOTIFY_PREFS_DEFAULT, ...(response || {}) })),
      catchError(() => of(RCS_NOTIFY_PREFS_DEFAULT)),
    );
  }

  /**
   * O PUT ignora `locked`, `available`, `default_address`, `locked_events` e
   * `reminder_days` (o contrato é claro: eles não vêm desta tela), mas não custa
   * nada tirá-los daqui também, pra não mandar campo que não é nosso de mudar.
   */
  update(prefs: RcsNotifyPrefs): Observable<RcsNotifyPrefs> {
    const body = {
      channels: {
        panel: { enabled: true },
        email: { enabled: prefs.channels.email.enabled, addresses: prefs.channels.email.addresses },
        whatsapp: { enabled: prefs.channels.whatsapp.available ? prefs.channels.whatsapp.enabled : false },
        sms: { enabled: prefs.channels.sms.available ? prefs.channels.sms.enabled : false },
      },
      events: { ...prefs.events },
    };

    return this.http.put<RcsNotifyPrefs>(this.url, body);
  }
}
